<template>
  <div class="pagelist">
    <div style="text-align: right">
      <el-pagination background @current-change="pageCurrentChange" :page-count="pages" :current-page="pageNum" layout="prev, pager, next" :total="total" :page-size='pageSize'>
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pages: {
      type: Number
    },
     pageNum: {
      type: Number
    },
     total: {
      type: Number
    },
     pageSize: {
      type: Number
    },

  },
  data() {
    return {

    };
  },
  computed: {

  },
  created() {

  },
  methods: {
    pageCurrentChange(val, e, form, jobExpLabel, pageform, searchVal) {
      this.$emit('currentchange', val)
    },
  },
};
</script>

<style  lang="less">
</style>



// WEBPACK FOOTER //
// src/components/assessment/pagelist.vue